var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';

var Node = function Node(props) {
  var node = props.node,
      level = props.level,
      render = props.render,
      getNodeId = props.getNodeId,
      getNodeChildren = props.getNodeChildren,
      isNodeExpanded = props.isNodeExpanded,
      onToggleExpand = props.onToggleExpand,
      extraProps = _objectWithoutProperties(props, ['node', 'level', 'render', 'getNodeId', 'getNodeChildren', 'isNodeExpanded', 'onToggleExpand']);

  var childNodes = getNodeChildren(node);
  var isFolder = Array.isArray(childNodes);
  var hasChildNodes = isFolder && childNodes.length > 0;
  var isExpanded = isFolder && isNodeExpanded(node);
  return render(_extends({}, extraProps, {
    node: node,
    level: level,
    isFolder: isFolder,
    isExpanded: isExpanded,
    hasChildNodes: hasChildNodes,
    getToggleProps: isFolder ? function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _extends({
        tabIndex: '0',
        role: 'button'
      }, props, {
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();
          onToggleExpand(node);
        },
        onKeyDown: function onKeyDown(event) {
          if (event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            event.stopPropagation();
            onToggleExpand(node);
          }
        }
      });
    } : null,
    renderChildNodes: isFolder ? function () {
      return childNodes.map(function (childNode) {
        return React.createElement(Node, _extends({}, props, {
          key: getNodeId(childNode),
          node: childNode,
          level: level + 1
        }));
      });
    } : null
  }));
};

Node.propTypes = process.env.NODE_ENV !== "production" ? {
  node: PropTypes.object.isRequired,
  level: PropTypes.number,
  render: PropTypes.func.isRequired,
  getNodeId: PropTypes.func.isRequired,
  getNodeChildren: PropTypes.func.isRequired,
  isNodeExpanded: PropTypes.func.isRequired,
  onToggleExpand: PropTypes.func.isRequired
} : {};
Node.defaultProps = {
  level: 0
};
export default Node;